import { Grid, TextField, MenuItem, InputAdornment } from '@mui/material'

const FAMILY_OPTIONS = [
    { value: 'weight', label: 'Weight' },
    { value: 'volume', label: 'Volume' },
    { value: 'count', label: 'Count' },
]

/**
 * Shared field set for both the Create and Update stock unit dialogs.
 * Pure controlled inputs — parent owns the `values`/`errors` state and
 * passes down a single onChange(field, value) handler.
 */
const StockUnitForm = ({ values, errors = {}, onChange, disabled = false }) => {
    const handle = (field) => (e) => onChange(field, e.target.value)

    return (
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <TextField fullWidth label="Name" placeholder="e.g. Kilogram, Gram, Packet, ..." value={values.name || ''} onChange={handle('name')} error={!!errors.name} helperText={errors.name} disabled={disabled} />
        </Grid>
    )
}

export default StockUnitForm